import clsx from 'clsx';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ArrowDownIcon, PlusIcon, SethoscopeIcon } from '../../../Assets/icons';
import AccordionItem from '../../UI/AccordionItem';
import AccordionWrapper from '../../UI/AccordionWrapper';
import Button from '../../UI/Button';
import Pills from '../../UI/Pills';
import classes from './ServicesAction.module.css';
import { numberFormatter } from '../../../Helpers';
import { addQuantityInSelectedServiceList, setSelectedService } from '../../../Store/serviceSlice';
const AccordionHeader = () => {
  return (
    <span className={classes.wrapper}>
      <span className={classes.frame}>
        <SethoscopeIcon color="var(--primary-color)" size={20} />
      </span>
      <span className={classes.name}>Service(s)</span>
    </span>
  );
};
let runFirstTime = 1;
const ServicesAction = ({
  onClick,
  value = [],
  setter = () => {},
  isView = false,
  show,
  onView
}) => {
  const dispatch = useDispatch();
  const selectedServices = useSelector((state) => state?.serviceReducer.selectedServices); //here we get all selected services that we select by checkbox of CreateAndViewServices
  const services = useSelector((state) => state?.serviceReducer?.services);
  useEffect(() => {
    setter([...selectedServices]);
  }, [selectedServices]);
  //set all ids of services for comparing either this values is in the state or not
  //for rendering only selected options
  const decideSelectedServicesOption = selectedServices;
  let decideUnSelectedServices = services;
  // This functions toggle the select value if the value is not in the state set the value else remove the value
  const interchangeService = (selectedData) => {
    const existingItemIndex = decideSelectedServicesOption?.findIndex(
      (item) => item?.serviceId === selectedData?.serviceId
    );
    if (existingItemIndex !== -1) {
      // Item already exists, create a new updated object
      const updatedService = [...decideSelectedServicesOption];
      updatedService[existingItemIndex] = {
        ...updatedService[existingItemIndex], // Copy the existing item
        quantity: updatedService[existingItemIndex].quantity + 1 // Increment quantity
      };
      if (selectedData?.serviceId === null) {
      }
      setter(updatedService);
    } else {
      // Add a new item (ensure immutability)
      setter([...decideSelectedServicesOption, { ...selectedData, quantity: 1 }]);
    }
    dispatch(addQuantityInSelectedServiceList(selectedData));
  };
  useEffect(() => {
    if (show) {
      if (!decideSelectedServicesOption?.find((data) => data?.serviceId == null)) {
        dispatch(
          setSelectedService([
            ...selectedServices,
            services?.find((data) => data?.serviceId == null)
          ])
        );
      }
    }
  }, [show, services]);
  const handleDelete = (id) => {
    const index = decideSelectedServicesOption.findIndex((item, indx) => indx === id); // Find the index of the item
    if (index !== -1) {
      const updatedItems = [...decideSelectedServicesOption]; // Create a copy of the array
      updatedItems.splice(index, 1); // Remove the item at the found index
      setter(updatedItems); // Update the state
      dispatch(setSelectedService([...updatedItems]));
    }
  };

  const decreaseFromServices = (serviceId) => {
    const updatedServices = [...selectedServices]
      .map((item) =>
        item.serviceId === serviceId ? { ...item, quantity: item.quantity - 1 } : item
      )
      .filter((item) => item.quantity > 0 || item?.serviceId === null); // Filter out items with quantity 0
    dispatch(setSelectedService([...updatedServices]));

    setter(updatedServices);
  };

  useEffect(() => {}, [show]);
  if (decideSelectedServicesOption?.find((ele) => ele?.serviceId == null)) {
    decideUnSelectedServices = services?.filter((ele) => ele?.serviceId != null);
  }
  return (
    <AccordionWrapper className={classes.accordionWrapper} show={show}>
      <AccordionItem
        className={classes.accordionItem}
        eventKey={'service'}
        header={<AccordionHeader />}>
        <div className={clsx(classes.selectedWrapper, classes.grid)}>
          {decideSelectedServicesOption?.map((data, indx) => (
            <Pills
              key={indx}
              data={data}
              selected={true}
              cross={true}
              label={`${data?.serviceName} (${numberFormatter(data?.serviceFees)})  ${
                data?.serviceId != null && data?.quantity ? 'X' + data?.quantity : ''
              }`}
              onClick={() => {
                // data?.serviceId === null && interchangeService(data);
              }}
              onMinus={() => {
                if (data?.serviceId === null) {
                  dispatch(
                    setSelectedService(selectedServices?.filter((data) => data?.serviceId != null))
                  );
                } else {
                  decreaseFromServices(data?.serviceId);
                }
              }}
            />
          ))}
        </div>
        <div className={classes.optionsWrapper}>
          <div className={classes.headerSection}>
            <h3>Include More</h3>
            <span
              className={classes.actionWrapper}
              onClick={() => {
                if (typeof onClick === 'function') {
                  onClick();
                }
              }}>
              <PlusIcon color="var(--primary-color)" />
              <span className={classes.action}>Create New</span>
            </span>
          </div>

          <div className={clsx(classes.optionsWrapper, classes.grid)}>
            {decideUnSelectedServices?.map((data) => (
              <Pills
                data={data}
                selected={false}
                cross={false}
                label={`${data?.serviceName} (${data?.serviceFees})`}
                // onClick={() => {
                //   interchangeService(data);
                // }}
                onAdd={() => {
                  interchangeService(data);
                }}
              />
            ))}
          </div>

          {onView && (
            <div className={classes.viewWrapper}>
              <Button
                className={classes.viewBtn}
                variants="transparent"
                onClick={() => {
                  if (typeof onView === 'function') {
                    onView();
                  }
                }}>
                <span>View All</span>
                <span>
                  <ArrowDownIcon color="var(--primary-color)" />
                </span>
              </Button>
            </div>
          )}
        </div>
      </AccordionItem>
    </AccordionWrapper>
  );
};

export default ServicesAction;
